import React from 'react';

function LandingInfoContentSection({ children }): JSX.Element {
  const style = {
    display: 'flex',
    justifyContent: 'center',
    maxWidth: 1728,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: 16,
    paddingRight: 16
  };
  return <div css={style}>{children}</div>;
}

export default LandingInfoContentSection;
